/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Theme_ToggleInputs */

const en_mk_theme_toggle = /** @type {(inputs: Mk_Theme_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch light / dark theme`)
};

const id_mk_theme_toggle = /** @type {(inputs: Mk_Theme_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganti tema terang / gelap`)
};

/**
* | output |
* | --- |
* | "Switch light / dark theme" |
*
* @param {Mk_Theme_ToggleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_theme_toggle = /** @type {((inputs?: Mk_Theme_ToggleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Theme_ToggleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_theme_toggle(inputs)
	return en_mk_theme_toggle(inputs)
});